import Analytics from '../../../../../pkg/analytics.js';
import { AnalyticsProvider as ProviderAlias, useAnalytics as useAnalyticsAlias } from '../../../../../pkg/use-analytics.js';
import { Identify } from './analytics/Identify.js';
import fullstoryPlugin from './fullstory/fullstoryPlugin.js';
import googleAnalytics4Plugin from './google-analytics-4/googleAnalytics4Plugin.js';
import { hubSpotPlugin } from './hubspot/index.js';
import { getPendo } from './pendo/getPendo.js';
import { pendoPlugin } from './pendo/pendoPlugin.js';
const AnalyticsProvider = ProviderAlias;
const useAnalytics = useAnalyticsAlias;
export { Analytics, AnalyticsProvider, Identify, useAnalytics };
export const pendo = {
    pendoPlugin,
    getPendo,
};
export const fullstory = {
    fullstoryPlugin,
};
export const ga4 = {
    ga4Plugin: googleAnalytics4Plugin,
};
export const hubspot = {
    hubSpotPlugin,
};
